export function buildEventStartDate(startDate, formatEventDate) {
    if (formatEventDate === undefined) {
        return startDate;
    }
    const eventDateDetails = formatEventDate(startDate);
    if (eventDateDetails.daysAway > 1) {
        return eventDateDetails.formattedDate;
    }
    return `${eventDateDetails.dayPhrase} ${eventDateDetails.formatterTime}`;
}
//# sourceMappingURL=buildEventStartDate.js.map